// extracted by mini-css-extract-plugin
export default {"wrapper":"GDPR_wrapper__g8SBI","title":"GDPR_title__RWBvY","article":"GDPR_article__Ypk35","paragraph":"GDPR_paragraph__LHOLS","email":"GDPR_email__071qi"};